module.exports = __webpack_public_path__ + "static/media/world.a22a8987.svg";